import EMutabakat from './e-mutabakat';

export default EMutabakat;
